import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { fetchNavi, switchLang } from '../../redux/actions';
import LangWrapper from '../../components/LangWrapper';
import { fetchMenu, fetchDate } from '../../redux/actions';
import slug from 'slug'

import SubNav from '../../components/SubNav';

import './Header.css';
import './MobileNav.css';

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      navigationOpen: false,
      menuOpen: false,
    }
  }

  componentDidMount() {
    const locale = this.props.intl.locale;

    this.props.fetchDate();

    if (!this.props.navi) {
      this.props.fetchNavi(locale);
    }

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }

    let lastScrollTop = 0

    window.addEventListener('scroll', function() {
      let nav = document.querySelector('header.sticky-header')
      let st = window.pageYOffset || document.documentElement.scrollTop

      if (st > lastScrollTop){
        // downscroll
        if(window.pageYOffset > nav.offsetHeight) {
          nav.classList.remove('full')
          nav.classList.add('hide')
          if(window.pageYOffset > 500) {
            nav.classList.remove('hide')
            nav.classList.add('sticky')
          }
        }
      } else {
        // upscroll

        if(window.pageYOffset > 500) {
          nav.classList.add('full')
        }
        else {
          nav.classList.add('hide')
          if(window.pageYOffset < 300) {
            nav.classList.remove('sticky')
            nav.classList.remove('full')
            nav.classList.remove('hide')
          }
        }
      }
      lastScrollTop = st;
    })
  }

  componentDidUpdate() {
    window.scroll(0, 0);
  }

  handleNavToggle() {
    if(this.state.navigationOpen) {
      this.setState({
        navigationOpen: false
      })
    }
    else {
      // if(window.innerWidth <= 767) {
        this.setState({
          navigationOpen: true
        })
      // }
    }
  }

  handleMenu() {
    if(this.state.menuOpen) {
      this.setState({
        menuOpen: false
      })
    }
    else {
      this.setState({
        menuOpen: true
      })
    }
  }

  onSwitchLang() {
    this.props.switchLang();
    window.location.reload();
  }

  render() {
    const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }
    const locale = this.props.intl.locale;
    const {naviItems, menus, match} = {...this.props};
    const currentSlug = match.params.slug;
    const date = this.props.date;
    
    const currentPath = this.props.location.pathname;

    const restaurants = [
      {
        parent: '/menu/galleria',
        link: '/menu/galleria',
        value: 'Galleria',
        hidden: false,
        title: 'Levain Galleria',
      },
      {
        parent: '/menu/merikortteli',
        link: '/menu/merikortteli',
        value: 'Merikortteli',
        hidden: false,
        title: 'Levain Merikortteli',
      },
      {
        parent: '/menu/toolo',
        link: '/menu/toolo',
        value: 'Töölö',
        hidden: false,
        title: 'Levain Töölö',
      },
      {
        parent: '/menu/ullanlinna',
        link: '/menu/ullanlinna',
        value: 'Ullanlinna',
        hidden: false,
        title: 'Levain Ullanlinna',
      },
    ];
    
  const selectedRestaurant = restaurants.find(restaurant =>
    currentPath === restaurant.parent ||
    currentPath.indexOf(`${restaurant.parent}/`) === 0
  );

  const restaurantMenus = selectedRestaurant
    ? menus.filter(item => {
        const itemRestaurants = item.fields.restaurant;

        return (
          Array.isArray(itemRestaurants) &&
          itemRestaurants.includes(selectedRestaurant.value)
        );
      })
    : [];

  const createMenuItems = (
  menuItems,
  restaurant = null,
  forceVisible = false
) =>
  menuItems.map(item => {
    const menuSlug = slug(item.fields.title.toLowerCase());

    let link = restaurant
      ? `${restaurant.link}/${menuSlug}`
      : `/menu/${menuSlug}`;

    const parent = link;

    if (item.fields.children) {
      const validChildren = item.fields.children.filter(category =>
        isItemValid(category, date)
      );

      const firstChild = validChildren[0];

      if (
        item.fields.parentMenu &&
        firstChild &&
        firstChild.sys.contentType &&
        firstChild.sys.contentType.sys.id === 'menu'
      ) {
        link = `${link}/${slug(firstChild.fields.title.toLowerCase())}`;
      }
    }

    return {
      parent,
      link,
      hidden: forceVisible
        ? false
        : !item.fields.showInNavigation,
      title: item.fields.title,
    };
  });
  
  const restaurantItems = restaurants.map(restaurant => {
      const menusForRestaurant = menus.filter(item => {
        const itemRestaurants = item.fields.restaurant;

        return Array.isArray(itemRestaurants) && itemRestaurants.includes(restaurant.value);
      });

      const firstMenuItem = createMenuItems(menusForRestaurant, restaurant, true)[0];

      return {
        ...restaurant,
        parent: firstMenuItem ? restaurant.parent : null,
        link: firstMenuItem ? firstMenuItem.link : '/menu',
        disableActive: !firstMenuItem,
      };
    });

  const mainMenuItems = [
    ...restaurantItems,
    ...createMenuItems(menus),
  ];

  const restaurantMenuItems = selectedRestaurant
  ? createMenuItems(
      restaurantMenus,
      selectedRestaurant,
      true
    )
  : [];

    let children;

    return (
      <header className="sticky-header">
        <NavLink to={locale==='en'?'/en':'/'}><span className="logo">Levain Bakery Eatery</span></NavLink>
        <nav>
          <NavLink to="/menu" activeClassName="active">{this.props.intl.messages["header.foodAndDrinks"]}</NavLink>
          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                if (isCurrent) {
                  children = item.childPages;
                }
              }

              return (
                <NavLink key={`navilink_${i}`} to={`/${mainPage.fields.slug}`} activeClassName="active" className={isCurrent?'active':null}>
                  {item.label}
                </NavLink>
              );
            })
          }
          <NavLink to="/contact" activeClassName="active">{this.props.intl.messages["header.contactUs"]}</NavLink>

          { children &&
            <SubNav
              onNav={() => this.handleNavToggle()}
              items={children.map(item => ({
                link: `/${item.fields.slug}`,
                hidden: false,
                title: item.fields.title,
              })
            )} />
          }

          {currentPath.indexOf('/menu') === 0 &&
          <SubNav
            currentPath={currentPath}
            onNav={() => this.handleNavToggle()}
            items={mainMenuItems}
          />
        }

        {selectedRestaurant && restaurantMenuItems.length > 0 &&
          <SubNav
            currentPath={currentPath}
            onNav={() => this.handleNavToggle()}
            items={restaurantMenuItems}
          />
        }
        </nav>

    <Link to="/reservation" className="reservation btn_reservation" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.bookTable"]}</Link>
    <NavLink to="/lahjakortti" className="reservation gifts" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.giftBtn"]}</NavLink>
        <LangWrapper onSwitch={() => this.onSwitchLang()} />

        <span className="nav-toggle" onClick={this.handleNavToggle.bind(this)}><span /><span /><span /></span>

        <nav className={'mobile-nav '+(this.state.navigationOpen ? 'open' : '')}>
          <span className="close" onClick={this.handleNavToggle.bind(this)} />

          <LangWrapper onSwitch={() => this.onSwitchLang()} />

          <NavLink to={locale==='en'?'/en':'/'} className="logo" onClick={this.handleNavToggle.bind(this)}><span>Levain Bakery Eatery</span></NavLink>

          <NavLink to="/menu" activeClassName="active" onClick={this.handleNavToggle.bind(this)}
        >
          {this.props.intl.messages["header.foodAndDrinks"]}
        </NavLink>

        {currentPath.indexOf('/menu') === 0 &&
            <nav className="subnav">
              {restaurantItems.map((restaurant, i) => {
                const active = selectedRestaurant && selectedRestaurant.value === restaurant.value;

                return(
                  <span className="restaraunt_menu" key={`restaurant_${i}`}>
                    <NavLink className={active?'active':null} activeClassName={restaurant.disableActive?'':'active'} exact={restaurant.disableActive} to={restaurant.link} onClick={() => this.handleNavToggle()}>{restaurant.title}</NavLink>

                    {active && restaurantMenuItems.length > 0 &&
                      <SubNav currentPath={currentPath} onNav={() => this.handleNavToggle()} items={restaurantMenuItems} />
                    }
                  </span>
                )
              })}

              <SubNav currentPath={currentPath} onNav={() => this.handleNavToggle()} items={createMenuItems(menus)} />
            </nav>
          }

          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              let children;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                if (isCurrent) {
                  children = item.childPages;
                }
              }

              return (
                <span key={`navilink_${i}`}>
                  <NavLink to={`/${mainPage.fields.slug}`} activeClassName="active" onClick={this.handleNavToggle.bind(this)}>
                    {item.label}
                  </NavLink>
                  { children &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={children.map(item => ({
                        link: `/${item.fields.slug}`,
                        hidden: false,
                        title: item.fields.title,
                      })
                    )} />
                  }
                </span>
              );
            })
          }
          <NavLink to="/contact" activeClassName="active" onClick={this.handleNavToggle.bind(this)}><FormattedMessage id="header.contactUs" /></NavLink>

      <Link to="/reservation" className="reservation" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.bookTable"]}</Link><br />
      <NavLink to="/lahjakortti" className="reservation gifts" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.giftBtn"]}</NavLink>
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  naviItems: state.navi,
  menus: state.menus,
  date: state.date,
});

const mapDispatchToProps = {
  fetchNavi,
  fetchMenu,
  fetchDate,
  switchLang
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header)));



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js